// 当商品价格为0是显示文字电联
export const showPrice0 = '电联'